// Centralized data-testids for the marketing site.
export const TESTIDS = {
  nav: {
    container: "site-navbar",
    logo: "nav-logo",
    linkHome: "nav-link-home",
    linkAbout: "nav-link-about",
    linkServices: "nav-link-services",
    linkTreatments: "nav-link-treatments",
    linkFaq: "nav-link-faq",
    linkContact: "nav-link-contact",
    ctaSchedule: "nav-cta-schedule",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    section: "hero-section",
    ctaSchedule: "hero-cta-schedule",
    ctaLearnMore: "hero-cta-learn-more",
    headline: "hero-headline",
  },
  about: {
    section: "about-section",
    title: "about-title",
    licenseBadge: "about-license-badge",
  },
  services: {
    section: "services-section",
    cardPsychotherapy: "service-card-psychotherapy",
    cardMusicTherapy: "service-card-music-therapy",
  },
  treatments: {
    section: "treatments-section",
    card: (key) => `treatment-card-${key}`,
    cta: "treatments-cta",
  },
  faq: {
    section: "faq-section",
    accordion: "faq-accordion",
    item: (i) => `faq-item-${i}`,
  },
  testimonials: {
    section: "testimonials-section",
    card: (i) => `testimonial-card-${i}`,
  },
  instagram: {
    section: "instagram-section",
    cta: "instagram-cta",
  },
  contact: {
    section: "contact-section",
    form: "contact-form",
    fieldName: "contact-field-name",
    fieldEmail: "contact-field-email",
    fieldPhone: "contact-field-phone",
    fieldReason: "contact-field-reason",
    submit: "contact-submit",
    success: "contact-success",
    instagramBtn: "contact-instagram-btn",
  },
  footer: {
    container: "site-footer",
    instagram: "footer-instagram",
  },
  whatsappFab: "whatsapp-fab",
};

export const SCHEDULE_FORM_URL =
  "https://wa.me/522206464457?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20consulta%20de%20Musicoterapia%20Humanista.";

export const WHATSAPP_URL = SCHEDULE_FORM_URL;
export const WHATSAPP_NUMBER = "+52 220 646 4457";

export const INSTAGRAM_URL = "https://www.instagram.com/musicoterapiahtoluca/";
export const INSTAGRAM_HANDLE = "@musicoterapiahtoluca";
export const LOCATION = "Toluca Centro, Estado de México";
